import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-no-network',
    imports: [],
    templateUrl: './no-network.component.html',
    styleUrl: './no-network.component.scss'
})
export class NoNetworkComponent implements OnInit {
    online = navigator.onLine;

    constructor(private router: Router) {

    }

    ngOnInit(): void {
        if (this.online) {
            this.router.navigate(['/']);
        }

        window.addEventListener('online', () => {
            this.router.navigate(['/']);
        });
    }

}
